<template>
    <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear>
    <v-card tile flat v-else>
        <v-alert
            v-if="itemsFiltered.length > 1"
            class="click"
            :type="highestSeverity"
            :value="true"
            :color="alertColor(highestSeverity)"
            @click="showAlerts = !showAlerts"
        >
            <w-alert-content
                :font-size="fontSize"
                :font-weight="fontWeight"
                :title="containerAlertText"
                :icon="showAlerts ? 'arrow_drop_up' : 'arrow_drop_down'"
                @click="showAlerts = !showAlerts"
            ></w-alert-content>
        </v-alert>
        <template v-if="showAlerts || itemsFiltered.length === 1">
            <v-alert
                v-for="(alert, i) in itemsFiltered"
                :class="{'click': alert.content.data.route}"
                :key="i"
                :type="alert.type"
                :value="alert.show"
                :color="alertColor(alert.type)"
                @click="alert.content.data.route ? $router.push(alert.content.data.route) : null"
            >
                <w-alert-content
                    :font-size="fontSize"
                    :font-weight="fontWeight"
                    :title="alert.content.data.route ? alert.content.data.text : alert.content.data"
                    :route="alert.content.data.route ? alert.content.data.route : false"
                ></w-alert-content>
            </v-alert>
        </template>
    </v-card>
</template>

<script>
    import WAlertContent from './WAlertContent'

    export const ALERT_TYPES = {
        warning: 'warning',
        info: 'info',
        error: 'error',
        success: 'success'
    }

    /**
     * Component that spans customisable alert dialogs through a simple and configurable items object.
     */
    export default {
        name: 'WAlerts',
        data: () => ({showAlerts: false}),
        components: {
            WAlertContent
        },
        props: {
            /**
             * Description of alert items
             */
            description: {
                type: String,
                default: ''
            },
            /**
             * Default font size
             */
            fontSize: {
                type: String,
                default: 'subheading'
            },
            /**
             * Default font weight
             */
            fontWeight: {
                type: String,
                default: 'medium'
            },
            /**
             * Alert items, containing {show: Boolean, type: String, content: {type: 'String', data: 'String | Array'}}.
             */
            items: {
                type: Array,
                default: () => ([
                    {
                        show: true,
                        type: 'success',
                        content: {
                            type: 'text',
                            data: 'This contract is active'
                        }
                    }
                ])
            },
            /**
             * Display horizontal field loading bar.
             */
            loading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            containerAlertText () {
                const vm = this
                const seeMoreText = vm.showAlerts ? 'hide all...' : 'see all...'
                const description = vm.description ? ` ${vm.description} ` : ''
                const totalItems = vm.itemsFiltered.length

                return `There are ${totalItems}${description} alerts (${seeMoreText})`
            },
            itemsSorted () {
                const vm = this
                return _.sortBy(vm.items, (item) => {
                    switch (item.type) {
                        case ALERT_TYPES.error:
                            return 1
                        case ALERT_TYPES.warning:
                            return 2
                        default:
                            return 3
                    }
                })
            },
            itemsFiltered () {
                const vm = this
                return _.filter(vm.itemsSorted, (item) => item.show)
            },
            highestSeverity () {
                const vm = this
                const types = _.pluck(vm.itemsFiltered, 'type')

                if (_.contains(types, ALERT_TYPES.error)) {
                    return ALERT_TYPES.error
                }

                if (_.contains(types, ALERT_TYPES.warning)) {
                    return ALERT_TYPES.warning
                }

                if (_.contains(types, ALERT_TYPES.info)) {
                    return ALERT_TYPES.info
                }

                return ALERT_TYPES.success
            },
            alertColor () {
                return (type) => {
                    switch (type) {
                        case 'warning':
                            return 'warningAlert'
                        case 'info':
                            return 'info'
                        case 'error':
                            return 'errorAlert'
                        case 'success':
                            return 'success'
                        default:
                            return ''
                    }
                }
            }
        }
    }
</script>
